import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mt-2 flex flex-col gap-2"
}
const _hoisted_2 = {
  href: "https://knack.navattic.com/3-main-areas",
  target: "_blank",
  class: "self-start hover:bg-transparent flex flex-row items-center gap-1 p-2 text-sm font-medium text-emphasis",
  rel: "noreferrer"
}

import { computed } from 'vue';
import Icon from '@/components/ui/Icon.vue';
import ChecklistsTitle from '@/components/checklists/ChecklistsTitle.vue';
import ChecklistsProgress from '@/components/checklists/ChecklistsProgress.vue';
import useChecklists from '@/checklists/useChecklists';
import ChecklistsSection from '@/components/checklists/ChecklistsSection.vue';
import ChecklistsExpandedSection from '@/components/checklists/ChecklistsExpandedSection.vue';

interface Props {
  onSectionClick: (sectionId: string) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsMainContent',
  props: {
    onSectionClick: { type: Function }
  },
  setup(__props: any) {


const { totalCompleted, totalCount, sections } = useChecklists();



const sectionIds = Object.keys(sections.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ChecklistsTitle),
    _createVNode(ChecklistsProgress, {
      steps: {completed: _unref(totalCompleted), total: _unref(totalCount)}
    }, null, 8, ["steps"]),
    (_unref(sectionIds).length === 1)
      ? (_openBlock(), _createBlock(ChecklistsExpandedSection, {
          key: 0,
          "can-go-back": false,
          "section-id": _unref(sectionIds)[0]
        }, null, 8, ["section-id"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sectionIds), (sectionId) => {
            return (_openBlock(), _createBlock(ChecklistsSection, {
              key: sectionId,
              "on-click": () => __props.onSectionClick(sectionId),
              "section-id": sectionId
            }, null, 8, ["on-click", "section-id"]))
          }), 128))
        ])),
    _createElementVNode("a", _hoisted_2, [
      _createVNode(Icon, { type: "academic-cap" }),
      _createTextVNode(" Get to know the 3 main areas of Knack ")
    ])
  ], 64))
}
}

})